/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage, FormattedNumber } from 'js/lib/coursera.react-intl';

import { Grid, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/grading';

type Props = {
  suggestedInput: string;
  suggestedScore?: number | null;
  reviewPoints?: number | null;
};

const styles = {
  scoreContainer: () => css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

const MultiLineInputSuggestion = ({ suggestedInput, suggestedScore, reviewPoints }: Props) => {
  return (
    <Grid item container xs={12} alignItems="center">
      {typeof suggestedScore === 'number' && typeof reviewPoints === 'number' && (
        <Grid item xs={12} css={styles.scoreContainer}>
          <Typography2 component="p" variant="bodyPrimary" color="inherit">
            <Typography2 variant="subtitleMedium" component="span" color="inherit">
              <FormattedNumber value={suggestedScore} maximumFractionDigits={3} />
            </Typography2>
            <FormattedMessage
              message={_t(' out of {reviewPoints, plural, one {# point} other {# points}}')}
              reviewPoints={reviewPoints}
            />
          </Typography2>
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography2 component="p" color="inherit">
          {suggestedInput}
        </Typography2>
      </Grid>
    </Grid>
  );
};

export default MultiLineInputSuggestion;
